import { render, staticRenderFns } from "./my-aboutMe.vue?vue&type=template&id=f45ffc56&scoped=true&"
import script from "./my-aboutMe.vue?vue&type=script&lang=js&"
export * from "./my-aboutMe.vue?vue&type=script&lang=js&"
import style0 from "./my-aboutMe.vue?vue&type=style&index=0&id=f45ffc56&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45ffc56",
  null
  
)

export default component.exports